import React, { useEffect, useState } from "react";
import { LoaderComponent } from "../../component/LoaderComponent";
import {
  agentDataSelected,
  intersubcatSelected,
} from "../../Redux/IntermediaryReducer";
import { typeOfCalculator } from "../../Redux/InsurerReducer";
import Tree from "../../assets/images/vector-smart-object-copy-7.png";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { typeOfCal,partnerConstant} from "../../Constant";
import { useIsMobile } from "../../Hooks/useIsMobile";
import axios from "axios";
//import { Select } from "antd";
import Select from 'react-select';
import { decryptResponse, doEncryption, refA_refB_Chaneel_BCC, refA_refB_ParentAgencyId } from "../../utilities/lib";
import aesEcb from "aes-ecb";


const SPLogin = (props) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [showLoader, setShowLoader] = useState(false);
  const [spData, setSpData] = useState();
  const [businesscreditchannel, setBusinesscreditchannel] = useState();
  const isMobile = useIsMobile();
  const [refA, setRefA] = useState("");
  const [refB, setRefB] = useState("");
  const [refC, setRefC] = useState("");
  const [disbaleRefs, setDisableRef] = useState({refADisable: false, refBDisable: false})
  const [partnerName, setPartnerName] = useState("");
  const [selectedBranchId, setSelectedBranchId] = useState();
  const [selectedEmployee, setSelectedEmployee] = useState();
  const [selectedEmployeeCode, setSelectedEmployeeCode] = useState();
  const [partnerNameErr, setPartnerNameErr] = useState(false);
  const [selectedBranchIdErr, setSelectedBranchIdErr] = useState(false);
  const [selectedEmployeeErr, setSelectedEmployeeErr] = useState(false);
  const [selectedEmployeeCodeErr, setSelectedEmployeeCodeErr] = useState(false);
  const [refAErr , setRefAErr] = useState(false);
  const [refBErr , setRefBErr] = useState(false);
  const [refCErr , setRefCErr] = useState(false);

  
  const getAllData = () => {

    setShowLoader(true);
    const reqObj = {
      agentid: props.paramsData.agentId,
      intermedsubcatcd: props.paramsData.intermedsubcatcd,
      mobilenumber: props.paramsData.mobilenumber,
    }
    var config = {
      method: "post",
      url: process.env.REACT_APP_Base_Url + "intermediary/v1/getiamdata",
      headers: {
        "Content-Type": "application/json",
      },
      data: doEncryption(reqObj),
    };
    axios(config)
      .then(function (res) {
        if(res.data.response?.length == 0){
          return
        }
        let response = decryptResponse(res.data.response)
        response = JSON.parse(response);
        setSpData(response);
        setBusinesscreditchannel(response[0]?.businesscreditchannel);
        if ((refA_refB_ParentAgencyId.includes(response[0]?.parentagencyid)) || (refA_refB_Chaneel_BCC.includes(response[0]?.channel || response[0]?.businesscreditchannel))) {
          setDisableRef({...disbaleRefs, refADisable: response[0]?.refA?true:false, refBDisable: response[0]?.refB?true:false})
          setRefA(response[0]?.refA)
          setRefB(response[0]?.refB)
        }
        if (response.length == 1 && refA_refB_Chaneel_BCC.includes(response[0]?.channel || response[0]?.businesscreditchannel)) {
          setPartnerName(response[0]?.parentagencyname)
          setSelectedBranchId(response[0].branchId)
          setSelectedEmployee(response[0].employeeNameOrSPName)
          setSelectedEmployeeCode(response[0].employeeCodeOrSPCode)
        }
        if(response[0]?.businesscreditchannel === "350"  || response[0]?.businesscreditchannel === "375"){
          dispatch(
            intersubcatSelected({
              agentid: props.paramsData.agentId,
              intermedsubcatcd: props.paramsData.intermedsubcatcd,
            })
          );
        } else if (response?.length === 1) {
          let data = response?.[0];
          if (data) {
            data["businessFor"] = "self";
            data["flowType"] = "advisor";
            data["skip"] = props.paramsData.skip;
            data["authorization"] = props.paramsData.authorization;
            data["refA"] = "";
            data["refB"] = "";
            data["refC"] = "";
            data['dealerCode'] = props.paramsData.dealerCode
            data['applicationNum'] = props.paramsData.applicationNum
          }
          dispatch(agentDataSelected(data));
          dispatch(
            intersubcatSelected({
              agentid: props.paramsData.agentId,
              intermedsubcatcd: props.paramsData.intermedsubcatcd,
            })
          );
          if (props.paramsData.productName === "All Products") {
            navigate("/plan-selection");
          } else if (props.paramsData.productName === "Prohealth Prime") {
            navigate("/prohealth-prime");
            dispatch(typeOfCalculator(typeOfCal.prohealthPrime));
          } else if (props.paramsData.productName === "Lifetime Health") {
            navigate("/lifetime-health");
            dispatch(typeOfCalculator(typeOfCal.lifetime));
          } else if (props.paramsData.productName === "Prime Senior") {
            navigate("/prime-senior");
            dispatch(typeOfCalculator(typeOfCal.primeSenior));
          } else if (props.paramsData.productName === "Prohealth") {
            navigate("/prohealth-insurance");
            dispatch(typeOfCalculator(typeOfCal.prohealth));
          } else if (props.paramsData.productName === "Super Top Up") {
            navigate("/super-top-up");
            dispatch(typeOfCalculator(typeOfCal.superTopUp));
          } else if (props.paramsData.productName === "Critical Illness") {
            navigate("/critical-illness");
            dispatch(typeOfCalculator(typeOfCal.ci));
          } else if (props.paramsData.productName === "Personal Accident") {
            navigate("/personal-accident");
            dispatch(typeOfCalculator(typeOfCal.pa));
          } else if (props.paramsData.productName === "Personal Accident") {
            navigate("/personal-accident");
            dispatch(typeOfCalculator(typeOfCal.pa));
          } else if (props.paramsData.productName === "Accident Shield") {
            navigate("/accident-shield");
            dispatch(typeOfCalculator(typeOfCal.accident_Shield));
          }else if (props.paramsData.productName === "Sarvah") {
            navigate("/sarvah");
            dispatch(typeOfCalculator(typeOfCal.mchiSarvah));
          }
        } else {
          dispatch(
            intersubcatSelected({
              agentid: props.paramsData.agentId,
              intermedsubcatcd: props.paramsData.intermedsubcatcd,
            })
          );
        }
        setShowLoader(false);
      })
      .catch(function (error) {
        console.log(error);
      });
  };
  useEffect(() => {
    getAllData();
  }, []);

  useEffect(() => {
    //data pre pop for bluechip case 
    if(spData && spData[0]?.parentagencyid == partnerConstant.BLUECHIP_PARENT_AGENT_ID){
        setPartnerName(spData[0].parentagencyname);
        console.log(uniqueBranchIds);
    } 
  }, [spData]);

  const checkValidFields = () => {
    let errors = {};
    if (!partnerName) {
      setPartnerNameErr(true);
      errors["partnerName"] = true;
    }
    if (!selectedBranchId) {
      setSelectedBranchIdErr(true);
      errors["selectedBranchId"] = true;
    }
    if (!selectedEmployee) {
      setSelectedEmployeeErr(true);
      errors["selectedEmployee"] = true;
    }
    if (!selectedEmployeeCode) {
      setSelectedEmployeeCodeErr(true);
      errors["selectedEmployeeCode"] = true;
    }
    if (spData[0].channel === "750" && spData[0].businesscreditchannel === "350") {
      if (!refA) {
        setRefAErr(true)
        errors["refA"] = true;
      }
      if (!refB) {
        setRefBErr(true)
        errors["refB"] = true;
      }
      if (!refC) {
        setRefCErr(true)
        errors["refC"] = true;
      }
    }
    //  if (spData[0].businesscreditchannel === "375") {
    //   if (!refA) {
    //     setRefAErr(true)
    //     errors["refA"] = true;
    //   }
    //   if (!refB) {
    //     setRefBErr(true)
    //     errors["refB"] = true;
    //   }
    //   if (!refC) {
    //     setRefCErr(true)
    //     errors["refC"] = true;
    //   }
    // }

    if (Object.keys(errors).length > 0) {
      return true;
    } else {
      return false;
    }
  };
  const onNextClick = () => {
    if (checkValidFields()) {
      return;
    }
    let data = spData.find(
      (employeeData) => employeeData.employeeNameOrSPName == selectedEmployee && employeeData.branchId === selectedBranchId
    );
    if (data) {
      data["businessFor"] = "partner";
      data["flowType"] = "advisor";
      data["skip"] = props.paramsData.skip;
      data["authorization"] = props.paramsData.authorization;
      data["refA"] = refA;
      data["refB"] = refB;
      data["refC"] = refC;
    }
    dispatch(agentDataSelected(data));
    if (props.paramsData.productName === "All Products") {
      navigate("/plan-selection");
    } else if (props.paramsData.productName === "Prohealth Prime") {
      navigate("/prohealth-prime");
      dispatch(typeOfCalculator(typeOfCal.prohealthPrime));
    } else if (props.paramsData.productName === "Lifetime Health") {
      navigate("/lifetime-health");
      dispatch(typeOfCalculator(typeOfCal.lifetime));
    } else if (props.paramsData.productName === "Prime Senior") {
      navigate("/prime-senior");
      dispatch(typeOfCalculator(typeOfCal.primeSenior));
    } else if (props.paramsData.productName === "Prohealth") {
      navigate("/prohealth-insurance");
      dispatch(typeOfCalculator(typeOfCal.prohealth));
    } else if (props.paramsData.productName === "Super Top Up") {
      navigate("/super-top-up");
      dispatch(typeOfCalculator(typeOfCal.superTopUp));
    } else if (props.paramsData.productName === "Personal Accident") {
      navigate("/personal-accident");
      dispatch(typeOfCalculator(typeOfCal.pa));
    } else if (props.paramsData.productName === "Critical Illness") {
      navigate("/critical-illness");
      dispatch(typeOfCalculator(typeOfCal.ci));
    } else if (props.paramsData.productName === "Personal Accident") {
      navigate("/personal-accident");
      dispatch(typeOfCalculator(typeOfCal.pa));
    } else if (props.paramsData.productName === "Accident Shield") {
      navigate("/accident-shield");
      dispatch(typeOfCalculator(typeOfCal.accident_Shield));
    }else if (props.paramsData.productName === "Sarvah") {
      navigate("/sarvah");
      dispatch(typeOfCalculator(typeOfCal.mchiSarvah));
    }
  };

  const uniqueBranchIds = spData &&
    spData.length > 0 && [
      ...new Map(spData.map((m) => [m.branchId, m])).values(),
    ];

  const arrayBranchIds =
    uniqueBranchIds &&
    uniqueBranchIds.length > 0 &&
    uniqueBranchIds.map((src, index) => {
      return (
        <option key={index} value={src.branchId}>
          {src.branchId}
        </option>
      );
    });

    const arrayOfBranch = uniqueBranchIds &&
    uniqueBranchIds.length > 0 &&
    uniqueBranchIds.map((item)=> {
      return(
        {'label': item.branchId , 'value': item.branchId}
      )
    })

  const arrayFilteredEmployeeDetails =
    spData &&
    spData.length > 0 &&
    spData.filter((spData) => spData.branchId == selectedBranchId);


  const arrayEmployeeDMSNames =
    arrayFilteredEmployeeDetails &&
    arrayFilteredEmployeeDetails.length > 0 &&
    arrayFilteredEmployeeDetails.map((src, index) => {
      return (
        <option key={index} value={src.employeeNameOrSPName}>
          {src.employeeNameOrSPName}
        </option>
      );
    });

  const arrayEmployeeDMSCodes =
    spData &&
    spData.length > 0 &&
    spData.find((spData) => spData.employeeNameOrSPName == selectedEmployee);

  const handleSelectedBrandId = (value) => {
    setSelectedBranchId(value);
    setSelectedEmployee("");
    setSelectedEmployeeCode("");
  };

  const handleSelectedEmployee = (value) => {
    setSelectedEmployee(value);
  };
  const handleSelectedEmployeeCode = (value) => {
    setSelectedEmployeeCode(value);
  };


  return (
    <>
      {showLoader && <LoaderComponent />}
      {(businesscreditchannel === '350' || businesscreditchannel === '375' || (businesscreditchannel !== '350' && spData?.length > 1)) && (
        <div className="App">
          <div className="bg_blue mt-5">
            <div className="row mt-5">
              <div
                className={
                  isMobile ? "col-md-12 p-0 text-center" : "col-md-12 p-0"
                }
              >
                <div
                  className={isMobile ? "jumbotron" : "jumbotron pt-3 p-4 mt-5"}
                  style={{ marginTop: `${isMobile ? "80px" : "0px"}` }}
                >
                  <h3 className="text-white">
                    Welcome{" "}
                    {props.paramsData.intermedsubcatcd === "SP"
                      ? spData && spData[0]?.agentName
                      : spData && spData[0].employeeNameOrSPName}
                  </h3>
                  <p className="text-white">
                    DMS Code -{" "}
                    {props.paramsData.intermedsubcatcd === "SP"
                      ? spData && spData[0].agentId
                      : spData && spData[0].employeeCodeOrSPCode}
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className="bg_light_blue mt-4">
            <div className="container mt-5">
              <div className="row" style={{ marginTop: "-100px" }}>
                {/* <div className="col-md-3">
                <div className="card p-5 bg-orange ">
                  <div className="mb-2">
                    <label className="mb-2">
                      SP Name
                      <i className="text-white">*</i>
                    </label>
                    <h6 className="card-subtitle mb-2">
                      {spData && spData[0].agentName}
                    </h6>
                  </div>
                  <div className="mb-2">
                    <label className="mb-2">
                      SP Code
                      <i className="text-white">*</i>
                    </label>
                    <h6 className="card-subtitle mb-2">
                      {spData && spData[0].agentId}
                    </h6>
                  </div>
                  <div className="mb-2">
                    <label className="mb-2">Channel</label>
                    <h6 className="card-subtitle mb-2">
                      {spData && spData[0].channel}
                    </h6>
                  </div>
                </div>
              </div> */}
                <div>
                  <div className="card p-4">
                    <div className="container" style={{ display: "grid" }}>
                      <div className="row">
                        <div className="col-md-4 p-3">
                          <div className="input_icon form-group label_mid">
                            <label className="mb-1">
                              <b>Partner Name</b>
                              <i className="red">*</i>
                            </label>
                            <select
                              className="form-select"
                              aria-label="Default select example"
                              value={partnerName}
                              onChange={(e) => setPartnerName(e.target.value)}
                            >
                              <option selected hidden>
                                Select
                              </option>
                              {/* {arrayPartnerNames} */}
                              <option>
                                {spData && spData[0].parentagencyname}
                              </option>
                            </select>
                          </div>
                          <div id="name-error" className="error font_12 red">
                            {!partnerName &&
                              partnerNameErr &&
                              "Please enter Partner Name"}
                          </div>
                        </div>
                        <div className="col-md-4 p-3">
                          <div className="input_icon form-group label_mid">
                            <label className="mb-1">
                              <b>Partner Branch Code</b>
                              <i className="red">*</i>
                            </label>
                            {/* <Select
                              showSearch
                              style={{
                                width: '100%'
                              }}
                              placeholder="Search to Select"
                              optionFilterProp="label"
                              filterSort={(optionA, optionB) =>
                                (optionA?.label ?? '').toLowerCase().localeCompare((optionB?.label ?? '').toLowerCase())
                              }
                              id="partner-branch-code"
                              allowClear
                              options={arrayOfBranch}
                              onChange={handleSelectedBrandId}
                            /> */}

                            <Select
                              className="basic-single"
                              classNamePrefix="select"
                              isClearable={true}
                              isSearchable={true}
                              {...((arrayBranchIds.length == 1  && businesscreditchannel == "375" )&& {
                                defaultValue: arrayOfBranch[0] 
                              })}
                              name="color"
                              options={arrayOfBranch}
                              onChange={(src)=>handleSelectedBrandId(src?.value)}
                              //value={selectedBranchId}
                            />
                            {/* <select
                              onChange={(e) =>
                                handleSelectedBrandId(e.target.value)
                              }
                              className="form-select"
                              aria-label="Default select example"
                            >
                              <option hidden selected>
                                Select
                              </option>
                              {arrayBranchIds}
                            </select> */}
                          </div>
                          <div id="name-error" className="error font_12 red">
                            {!selectedBranchId &&
                              selectedBranchIdErr &&
                              "Please enter Branch Code"}
                          </div>
                        </div>
                        <div className="col-md-4"></div>
                      </div>
                      <div className="row">
                        <div className="col-md-4 p-3">
                          <div className="input_icon form-group label_mid">
                            <label className="mb-1">
                              <b>Name</b>
                              <i className="red">*</i>
                            </label>
                            <select
                              className="form-select"
                              aria-label="Default select example"
                              onChange={(e) =>
                                handleSelectedEmployee(e.target.value)
                              }
                              value={selectedEmployee}
                            >
                              <option hidden selected>
                                Select
                              </option>
                              {arrayEmployeeDMSNames}
                            </select>
                          </div>
                          <div id="name-error" className="error font_12 red">
                            {!selectedEmployee &&
                              selectedEmployeeErr &&
                              "Please enter Employee Name"}
                          </div>
                        </div>
                        <div className="col-md-4 p-3">
                          <div className="input_icon form-group label_mid">
                            <label className="mb-1">
                              <b>Code</b>
                              <i className="red">*</i>
                            </label>
                            <select
                              className="form-select"
                              aria-label="Default select example"
                              onChange={(e) =>
                                handleSelectedEmployeeCode(e.target.value)
                              }
                              value={selectedEmployeeCode}
                            >
                              <option hidden selected>
                                Select
                              </option>
                              {arrayEmployeeDMSCodes && (
                                <option>
                                  {arrayEmployeeDMSCodes.employeeCodeOrSPCode}
                                </option>
                              )}
                            </select>
                          </div>
                          <div id="name-error" className="error font_12 red">
                            {!selectedEmployeeCode &&
                              selectedEmployeeCodeErr &&
                              "Please enter Employee Code"}
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-md-4 p-3">
                          <div className="input_icon form-group label_mid">
                            <label className="mb-1">
                              <b>MCHI Branch Code</b>
                              <i className="red">*</i>
                            </label>
                            <input
                              className="form-control disabled-input text-center"
                              type="text"
                              value={
                                arrayEmployeeDMSCodes &&
                                arrayEmployeeDMSCodes.mappedirdalocation
                              }
                              aria-label="Disabled input example"
                              disabled
                              readOnly
                            />
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-md-4 p-3">
                          <label className="mb-1">
                            <b>Ref A</b>
                            <i className="red">*</i>
                          </label>
                          <textarea
                            className="form-control"
                            placeholder="Give description here"
                            id="floatingTextarea"
                            value={refA}
                            disabled={disbaleRefs.refADisable}
                            readOnly={disbaleRefs.refADisable}
                            {...(!disbaleRefs.refADisable && ({
                              onChange: (e) => setRefA(e.target.value)
                            }))}
                          ></textarea>
                          {!refA && refAErr && (
                            <div id="name-error" className="error font_12 red">
                              Please enter Ref A
                            </div>
                          )}
                        </div>
                        <div className="col-md-4 p-3">
                          <label className="mb-1">
                            <b>Ref B</b>
                             <i className="red">*</i>
                          </label>
                          <textarea
                            className="form-control"
                            placeholder="Give description here"
                            id="floatingTextarea"
                            value={refB}
                            disabled={disbaleRefs.refBDisable}
                            readOnly={disbaleRefs.refBDisable}
                            {...(!disbaleRefs.refBDisable && ({
                              onChange: (e) => setRefB(e.target.value)
                            }))}
                          ></textarea>
                           {!refB && refBErr && (
                            <div id="name-error" className="error font_12 red">
                              Please enter Ref B
                            </div>
                          )}
                        </div>
                        <div className="col-md-4 p-3">
                          <label className="mb-1">
                            <b>Ref C</b>
                            <i className="red">*</i>
                          </label>
                          <textarea
                            className="form-control"
                            placeholder="Give description here"
                            id="floatingTextarea"
                            value={refC}
                            onChange={(e) => setRefC(e.target.value)}
                          ></textarea>
                           {!refC && refCErr && (
                            <div id="name-error" className="error font_12 red">
                              Please enter Ref C
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div style={{ background: "#f5f5f5" }}>
            <div className="fixed mt-3">
              <div className="row">
                <div className="col-6">
                  <img
                    src={Tree}
                    alt="vector-smart-object-copy-7"
                    className="tree-image"
                  />
                </div>
                <div className="col-6 text-right" style={{ top: "45px" }}>
                  <button
                    onClick={() => onNextClick()}
                    className="btn btn-primary-custom"
                  >
                    NEXT &nbsp;
                    <i className="fa fa-angle-right"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default SPLogin;